import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltungen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsVeranstaltungenEffects {

    Veranstaltungen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNGEN),
        mergeMap((x: ac.GetVeranstaltungenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungen(x.nur_aktive, x.nur_mit_incidents).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungenErfolgreichAction(result, x.nur_aktive, x.nur_mit_incidents, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungenFehlerAction(error, x.nur_aktive, x.nur_mit_incidents, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
